import React from 'react';

const Loading = () => {
    return (
        <div className="loading-container">
            <div className="loading-content">
                <div className="loading-spinner">
                    <div className="spinner"></div>
                </div>
                <div className="loading-text">
                    <h3>Loading...</h3>
                    <p>Please wait while we prepare your experience</p>
                </div>
            </div>
        </div>
    );
};

export default Loading;
